import { useEffect, useState } from "react";
import { webUrlNode } from "../../constants/appInfo";
import { useSelector } from "react-redux";
import CreditRechargePanel from "./CreditRechargePanel";
import ItemWalletUI from "./Components/ItemWalletUI";
import ItemUsageUI from "./Components/ItemUsageUI";

export default function TenantEmailCreditDashboard() {

         const userId = useSelector((state)=>state?.user?.user?.user_id)
const currentToken = useSelector((state)=>state?.user?.user?.token);
          const appToken = useSelector((state)=>state?.app?.app?.AppToken);
 
       
const [tenantId,setTenantId] =useState(userId)
  const [wallet, setWallet] = useState(null);
  const [usage, setUsage] = useState([]);


  const [useCase, setUseCase] = useState(null);
  const [toEmail, setToEmail] = useState(null);
  const [from, setFrom] = useState(null);
  const [to, setTo] = useState(null);
  const [status, setStatus] = useState("created");

  const [loading, setLoading] = useState(false);

 const params = new URLSearchParams({
      channel: "email",
      ...(useCase ? { useCase } : {}),
      ...(toEmail ? { toEmail } : {}),
      ...(from ? { from } : {}),
      ...(to ? { to } : {}),
      ...(status?{status}:{}),
      limit: 50,tenantId,appToken,currentToken
    });
  useEffect(() => {
    load();
  }, [useCase,toEmail,from,to]);
  
  async function load() {
    setLoading(true);


    const w = await fetch(
      `${webUrlNode}/api/credits/wallet?channel=email&tenantId=${tenantId}&appToken=${appToken}&currentToken=${currentToken}`,
      
    ).then(r => r.json());

    const u = await fetch(
      `${webUrlNode}/api/credits/usage?${params.toString()}`,
      
    ).then(r => r.json());
   console.log(u)
    setWallet(w);
    setUsage(u || []);
   
    setLoading(false);
  }

  if (!wallet) return <div>Loading…</div>;

  return (

    <>
<ItemWalletUI
title={"Email Wallet"}
  wallet ={wallet}
 
 
 />

<CreditRechargePanel channel={"email"} />


 <ItemUsageUI
 title={"Email Usage"}

  usage={usage}
  loading={loading}
  useCase={useCase}
  setUseCase={setUseCase}
  toEmail={toEmail}
  setToEmail={setToEmail}
  from={from}
  setFrom={setFrom}
  to={to}
  setTo={setTo}
  load={load}
 />
    

    </>
  );
}
